import { render, staticRenderFns } from "./livingVideoView.vue?vue&type=template&id=655f3f5c&"
import script from "./livingVideoView.vue?vue&type=script&lang=js&"
export * from "./livingVideoView.vue?vue&type=script&lang=js&"
import style0 from "./livingVideoView.vue?vue&type=style&index=0&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports